<div
  class="tipo-novedad-container"
  [class.disabled-field]="disabled || readonly"
  [class.readonly-field]="readonly"
  [attr.inert]="readonly ? '' : null"
>
  <div class="form-row">
    <div class="col-3">
      <label class="field-label">Tipo de novedad *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <input
          matInput
          [formControl]="tipoNovedadControl"
          [matAutocomplete]="autoTipo"
          placeholder="Escriba para buscar o seleccionar..."
          autocomplete="off"
          (input)="onTipoNovedadInput($event)"
        />

        <mat-autocomplete
          #autoTipo="matAutocomplete"
          [displayWith]="displayTipoNovedad"
          (opened)="onTipoNovedadPanelOpened()"
          (optionSelected)="onTipoSelected($event.option.value)"
          panelClass="panel-tipo"
        >
          <mat-option *ngIf="isLoadingTipos" disabled>
            <div class="loading-content">
              <mat-spinner diameter="20"></mat-spinner>
              Cargando tipos de novedad...
            </div>
          </mat-option>

          <mat-option *ngIf="hasErrorTipos" disabled>
            <div class="error-state">
              <mat-icon>error</mat-icon>
              <span>Error al cargar tipos de novedad</span>
              <button
                mat-button
                (click)="retryLoadTipos(); $event.stopPropagation()"
              >
                <mat-icon>refresh</mat-icon>
                Reintentar
              </button>
            </div>
          </mat-option>

          <mat-option
            *ngFor="
              let tipo of filteredTiposNovedad$ | async;
              trackBy: trackByTipoCodigo
            "
            [value]="tipo"
          >
            <div class="option-layout">
              <span class="nombre">{{ tipo.nombre }}</span>
            </div>
          </mat-option>

          <mat-option
            *ngIf="
              (filteredTiposNovedad$ | async)?.length === 0 &&
              !isLoadingTipos &&
              !hasErrorTipos
            "
            disabled
          >
            <div class="no-results-content">
              <mat-icon>search_off</mat-icon>
              No se encontraron resultados
            </div>
          </mat-option>
        </mat-autocomplete>

        <button
          mat-icon-button
          matSuffix
          *ngIf="tipoNovedadControl.value"
          (click)="clearTipoSelection()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>

        <mat-error
          *ngIf="
            tipoNovedadControl.invalid &&
            (tipoNovedadControl.dirty || tipoNovedadControl.touched)
          "
        >
          {{ getFieldErrorMessage("tipo") }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3">
      <label class="field-label">Subtipo de novedad *</label>
      <div class="subtipo-container">
        <mat-form-field
          appearance="outline"
          class="select-field full-width"
          [class.disabled-field]="!subtipoHabilitado"
        >
          <input
            matInput
            [formControl]="subtipoNovedadControl"
            [matAutocomplete]="autoSubtipo"
            #subtipoTrigger="matAutocompleteTrigger"
            [disabled]="
              disabled ||
              !subtipoHabilitado ||
              (selectedTipoNovedad?.nombre || '')
                .toLowerCase()
                .includes('cambio de plan')
            "
            placeholder="Escriba para buscar o seleccionar..."
            autocomplete="off"
            (input)="onSubtipoNovedadInput($event)"
          />

          <mat-autocomplete
            #autoSubtipo="matAutocomplete"
            [displayWith]="displaySubtipoNovedad"
            (opened)="onSubtipoNovedadPanelOpened()"
            (optionSelected)="onSubtipoSelected($event.option.value)"
            panelClass="panel-subtipo"
          >
            <mat-option *ngIf="!subtipoHabilitado" disabled>
              <div class="no-results-content">
                <mat-icon>info</mat-icon>
                Seleccione primero un tipo de novedad con subtipos
              </div>
            </mat-option>

            <mat-option *ngIf="isLoadingSubtipos && subtipoHabilitado">
              <div class="loading-content">
                <mat-spinner diameter="20"></mat-spinner>
                Cargando subtipos...
              </div>
            </mat-option>

            <mat-option *ngIf="hasErrorSubtipos && subtipoHabilitado" disabled>
              <div class="error-state">
                <mat-icon>error</mat-icon>
                <span>Error al cargar subtipos</span>
                <button
                  mat-button
                  (click)="retryLoadSubtipos(); $event.stopPropagation()"
                >
                  <mat-icon>refresh</mat-icon>
                  Reintentar
                </button>
              </div>
            </mat-option>

            <mat-option
              *ngFor="
                let subtipo of filteredSubtiposNovedad$ | async;
                trackBy: trackBySubtipoId
              "
              [value]="subtipo"
              [disabled]="!subtipoHabilitado"
            >
              <div class="option-layout">
                <span class="nombre">{{ subtipo.nombre }}</span>
              </div>
            </mat-option>

            <mat-option
              *ngIf="
                !(filteredSubtiposNovedad$ | async)?.length &&
                !isLoadingSubtipos &&
                !hasErrorSubtipos &&
                subtipoHabilitado
              "
              disabled
            >
              <div class="no-results-content">
                <mat-icon>search_off</mat-icon>
                No se encontraron resultados
              </div>
            </mat-option>
          </mat-autocomplete>

          <button
            mat-icon-button
            matSuffix
            *ngIf="subtipoNovedadControl.value"
            (click)="clearSubSelection()"
            type="button"
          >
            <mat-icon>close</mat-icon>
          </button>

          <mat-error *ngIf="hasFieldError(subtipoNovedadControl, 'required')">
            {{ getFieldErrorMessage("subtipo") }}
          </mat-error>
        </mat-form-field>

        <div
          *ngIf="!subtipoHabilitado"
          [matTooltip]="
            'El campo Subtipo se habilita solo cuando el tipo de novedad seleccionado tiene parametrizado al menos un subtipo en estado activo'
          "
          matTooltipClass="tooltip-subtipo-custom"
          matTooltipPosition="below"
          class="tooltip-info-container"
        >
          <mat-icon class="info-icon">info</mat-icon>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="mensajeErrorTodosIntegrantesTrasladoNuevo">
      <div class="alert alert-warning" role="alert">
        <mat-icon>warning</mat-icon>
        <span>{{ mensajeErrorTodosIntegrantesTrasladoNuevo }}</span>
      </div>
    </div>

    <div
      class="col-12"
      *ngIf="
        esCambioTarifaSeleccionado() &&
        hasErrorTarifasCambio &&
        errorMessageTarifasCambio
      "
    >
      <div class="alert alert-warning" role="alert">
        <mat-icon>warning</mat-icon>
        <span>{{ errorMessageTarifasCambio }}</span>
      </div>
    </div>

    <!-- Campos para Cambio de tarifa (tipo 6) -->
    <div class="col-3" *ngIf="esCambioTarifaSeleccionado()">
      <label class="field-label">Tarifa *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <input
          matInput
          [formControl]="tarifaCambioControl"
          [matAutocomplete]="autoTarifaCambio"
          placeholder="Escriba para buscar..."
          autocomplete="off"
        />
        <mat-icon matSuffix *ngIf="!tarifaCambioControl.value">search</mat-icon>

        <mat-autocomplete
          #autoTarifaCambio="matAutocomplete"
          [displayWith]="displayTarifaCambio"
          (optionSelected)="onTarifaCambioSelected($event.option.value)"
          panelClass="panel-tarifa-cambio"
        >
          <mat-option *ngIf="isLoadingTarifasCambio" disabled>
            <div class="loading-content">
              <mat-spinner diameter="20"></mat-spinner>
              Cargando tarifas...
            </div>
          </mat-option>

          <mat-option *ngIf="hasErrorTarifasCambio" disabled>
            <div class="error-state">
              <mat-icon>error</mat-icon>
              <span>No se pudieron cargar las tarifas</span>
              <button
                mat-button
                type="button"
                (click)="retryLoadTarifasCambio(); $event.stopPropagation()"
              >
                <mat-icon>refresh</mat-icon>
                Reintentar
              </button>
            </div>
          </mat-option>

          <mat-option
            *ngFor="
              let tarifa of filteredTarifasCambio$ | async;
              trackBy: trackByTarifaCambioCodigo
            "
            [value]="tarifa"
          >
            <div class="option-layout">
              <span class="nombre"
                >{{ tarifa.codigo }} - {{ tarifa.nombre }}</span
              >
            </div>
          </mat-option>

          <mat-option
            *ngIf="
              (filteredTarifasCambio$ | async)?.length === 0 &&
              !isLoadingTarifasCambio &&
              !hasErrorTarifasCambio
            "
            disabled
          >
            <div class="no-results-content">
              <mat-icon>search_off</mat-icon>
              No se encontraron tarifas
            </div>
          </mat-option>
        </mat-autocomplete>

        <button
          mat-icon-button
          matSuffix
          *ngIf="tarifaCambioControl.value"
          (click)="clearTarifaCambioSelection()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="hasFieldError(tarifaCambioControl, 'required')">
          Tarifa es obligatoria
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3" *ngIf="esCambioTarifaSeleccionado()">
      <label class="field-label">Valor Total Cuota Mes con IVA *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [formControl]="valorTotalCuotaIvaControl"
          type="text"
          readonly
          [value]="
            valorTotalCuotaIvaControl.value
              | currency: 'COP' : 'symbol' : '1.2-2'
          "
          placeholder="$ 0"
        />
      </mat-form-field>
    </div>

    <div class="col-3-5" *ngIf="mostrarCampoColectivo">
      <label class="field-label">Colectivo *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <input
          matInput
          [formControl]="colectivoControl"
          [matAutocomplete]="autoColectivo"
          placeholder="Buscar por NIT o razón social..."
          [disabled]="disabled || isLoadingColectivos || !mostrarCampoColectivo"
          autocomplete="off"
        />
        <mat-icon matSuffix *ngIf="mostrarIconoBusquedaCampoColectivo()"
          >search</mat-icon
        >

        <mat-autocomplete
          #autoColectivo="matAutocomplete"
          [displayWith]="displayColectivo"
          (optionSelected)="onColectivoSelected($event.option.value)"
          panelClass="panel-colectivo"
        >
          <mat-option *ngIf="isLoadingColectivos" disabled>
            <div class="loading-content">
              <mat-spinner diameter="20"></mat-spinner>
              Cargando colectivos...
            </div>
          </mat-option>

          <mat-option *ngIf="hasErrorColectivos" disabled>
            <div class="error-state">
              <mat-icon>error</mat-icon>
              <span>Error al cargar colectivos</span>
              <button
                mat-button
                (click)="retryLoadColectivos(); $event.stopPropagation()"
              >
                <mat-icon>refresh</mat-icon>
                Reintentar
              </button>
            </div>
          </mat-option>

          <mat-option
            *ngFor="
              let colectivo of filteredColectivos$ | async;
              trackBy: trackByColectivoNit
            "
            [value]="colectivo"
          >
            <div class="option-layout">
              <div class="text-content">
                <span class="nit">{{ colectivo.nit }}</span>
                <span class="razon-social">{{ colectivo.razonSocial }}</span>
              </div>
            </div>
          </mat-option>

          <mat-option
            *ngIf="
              (filteredColectivos$ | async)?.length === 0 &&
              !isLoadingColectivos &&
              !hasErrorColectivos
            "
            disabled
          >
            <div class="no-results-content">
              <mat-icon>search_off</mat-icon>
              No se encontraron colectivos
            </div>
          </mat-option>
        </mat-autocomplete>

        <button
          mat-icon-button
          matSuffix
          *ngIf="colectivoControl.value"
          (click)="clearColectivoSelection()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="hasFieldError(colectivoControl, 'required')">
          Colectivo es obligatorio
        </mat-error>
      </mat-form-field>
      <div
        *ngIf="colectivoNoEncontrado"
        role="alert"
        style="color: #f44336; font-size: 12px; line-height: 1.2; margin-top: 4px"
      >
        El colectivo no se encuentra creado en Afilmed, por favor solicite la creación del colectivo para poder radicar novedad
      </div>
    </div>
    <!-- Tipo Plan, Programa y Tarifa destino — visible en línea solo para Cambio de Cobertura -->
    <ng-container
      *ngIf="mostrarCamposCambioCobertura && !mostrarCampoColectivo"
    >
      <div class="col-4">
        <label class="field-label">Tipo Plan destino *</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select
            [formControl]="tipoPlanDestinoControl"
            [compareWith]="compareByCodigoOrId"
            [disabled]="disabled"
          >
            <mat-option *ngFor="let tipoPlan of tiposPlanes" [value]="tipoPlan">
              {{ tipoPlan.nombre }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasFieldError(tipoPlanDestinoControl, 'required')">
            Tipo Plan destino es obligatorio
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <label class="field-label">Programa destino *</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select
            [formControl]="programaDestinoControl"
            [compareWith]="compareByCodigoOrId"
            [disabled]="disabled || isLoadingProgramas"
          >
            <mat-option disabled class="mat-option-filtro">
              <input
                type="text"
                placeholder="Buscar por código o nombre..."
                style="width: 100%; border: none; outline: none; padding: 4px 0"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                (input)="onFiltroProgramaDestinoInput($event)"
              />
            </mat-option>
            <mat-option *ngIf="isLoadingProgramas" disabled>
              <mat-spinner diameter="20"></mat-spinner> Cargando programas...
            </mat-option>
            <mat-option
              *ngFor="let programa of programasDestinoFiltradosBusqueda"
              [value]="programa"
            >
              {{ programa.programa || programa.nombre }}
            </mat-option>
            <mat-option
              *ngIf="
                programasDestinoFiltradosBusqueda.length === 0 &&
                !isLoadingProgramas
              "
              disabled
            >
              No se encontraron resultados
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasFieldError(programaDestinoControl, 'required')">
            Programa destino es obligatorio
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-4">
        <label class="field-label">Tarifa destino *</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select
            [formControl]="tarifaDestinoControl"
            [compareWith]="compareByCodigoOrId"
            [disabled]="disabled"
          >
            <mat-option disabled class="mat-option-filtro">
              <input
                type="text"
                placeholder="Buscar por código o nombre..."
                style="width: 100%; border: none; outline: none; padding: 4px 0"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                (input)="onFiltroTarifaDestinoInput($event)"
              />
            </mat-option>
            <mat-option
              *ngFor="let tarifa of tarifasDestinoFiltradasBusqueda"
              [value]="tarifa"
            >
              {{ tarifa.nombre }}
            </mat-option>
            <mat-option
              *ngIf="tarifasDestinoFiltradasBusqueda.length === 0"
              disabled
            >
              No se encontraron resultados
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasFieldError(tarifaDestinoControl, 'required')">
            Tarifa destino es obligatoria
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-2">
        <label class="field-label">Corte destino *</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select [formControl]="corteDestinoControl" [disabled]="disabled">
            <mat-option
              *ngFor="let corte of cortesDestino"
              [value]="corte.corte"
            >
              {{ corte.corte }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasFieldError(corteDestinoControl, 'required')">
            Corte destino es obligatorio
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </div>

  <!-- Fila 2: Incluir Anexo -->
  <div
    class="form-row"
    *ngIf="mostrarCamposCambioCobertura && !mostrarCampoColectivo"
  >
    <div class="col-4">
      <div class="checkbox-wrapper">
        <mat-checkbox
          color="primary"
          [formControl]="incluirAnexoControl"
          [matTooltip]="
            incluirAnexoControl.disabled
              ? 'Indique contrato en el paso 1 y programa destino para incluir anexos'
              : ''
          "
          matTooltipClass="tooltip-subtipo-custom"
          matTooltipPosition="above"
        >
          Incluir Anexo
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="form-row form-row-colectivo" *ngIf="mostrarCampoColectivo">
    <div class="col-2-5">
      <label class="field-label">Tipo Plan destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="tipoPlanDestinoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled"
          (selectionChange)="onTipoPlanDestinoColectivoSelected($event.value)"
        >
          <mat-option *ngFor="let tipoPlan of tiposPlanes" [value]="tipoPlan">
            {{ tipoPlan.nombre }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="hasFieldError(tipoPlanDestinoControl, 'required')">
          Tipo Plan destino es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3-5">
      <label class="field-label">Subcuenta destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="subcuentaDestinoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled"
        >
          <mat-option disabled class="mat-option-filtro">
            <input
              type="text"
              placeholder="Buscar por código o nombre..."
              style="width: 100%; border: none; outline: none; padding: 4px 0"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (input)="onFiltroSubcuentaDestinoInput($event)"
            />
          </mat-option>
          <mat-option
            *ngFor="let subcuenta of subcuentasDestinoFiltradasBusqueda"
            [value]="subcuenta"
          >
            {{ subcuenta.codigo }} - {{ subcuenta.nombre }}
          </mat-option>
          <mat-option
            *ngIf="subcuentasDestinoFiltradasBusqueda.length === 0"
            disabled
          >
            No se encontraron resultados
          </mat-option>
        </mat-select>
        <mat-error *ngIf="hasFieldError(subcuentaDestinoControl, 'required')">
          Subcuenta destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3-5">
      <label class="field-label">Sucursal comercializable destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="sucursalDestinoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled || !subcuentaDestinoControl.value"
        >
          <mat-option
            *ngFor="let sucursal of sucursalesDestino"
            [value]="sucursal"
          >
            {{ sucursal.codigo }} - {{ sucursal.nombre }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="hasFieldError(sucursalDestinoControl, 'required')">
          Sucursal comercializable destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="form-row form-row-colectivo" *ngIf="mostrarCampoColectivo">
    <div class="col-3-5">
      <label class="field-label">Programa destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="programaDestinoColectivoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled || !sucursalDestinoControl.value"
          (openedChange)="onPanelProgramaColectivoOpenedChange($event)"
        >
          <mat-option disabled class="mat-option-filtro">
            <input
              type="text"
              placeholder="Buscar por código o nombre..."
              style="width: 100%; border: none; outline: none; padding: 4px 0"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (input)="onFiltroProgramaDestinoColectivoInput($event)"
            />
          </mat-option>
          <mat-option
            *ngFor="let programa of programasDestinoColectivoFiltradosBusqueda"
            [value]="programa"
          >
            {{ programa.codigo }} - {{ programa.nombre }}
          </mat-option>
          <mat-option
            *ngIf="programasDestinoColectivoFiltradosBusqueda.length === 0"
            disabled
          >
            No se encontraron resultados
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="hasFieldError(programaDestinoColectivoControl, 'required')"
        >
          Programa destino es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3-5">
      <label class="field-label">Corte Subcuenta colectivo *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="corteSubcuentaControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled || !programaDestinoColectivoControl.value"
        >
          <mat-option *ngFor="let corte of cortesSubcuenta" [value]="corte">
            {{ corte.nombre }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="hasFieldError(corteSubcuentaControl, 'required')">
          Corte Subcuenta colectivo es obligatorio
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-row form-row-colectivo" *ngIf="mostrarCampoColectivo">
    <div class="col-3">
      <label class="field-label">Tarifa destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="tarifaDestinoColectivoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="disabled || !corteSubcuentaControl.value"
          panelClass="panel-tarifa-contrato"
        >
          <mat-option disabled class="mat-option-filtro">
            <input
              type="text"
              placeholder="Buscar por código o nombre..."
              style="width: 100%; border: none; outline: none; padding: 4px 0"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (input)="onFiltroTarifaDestinoColectivoInput($event)"
            />
          </mat-option>
          <mat-option
            *ngFor="let tarifa of tarifasDestinoColectivoFiltradasBusqueda"
            [value]="tarifa"
          >
            {{ tarifa.codigo }} | {{ tarifa.descripcion || tarifa.nombre }}
          </mat-option>
          <mat-option
            *ngIf="tarifasDestinoColectivoFiltradasBusqueda.length === 0"
            disabled
          >
            No se encontraron resultados
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="hasFieldError(tarifaDestinoColectivoControl, 'required')"
        >
          Tarifa destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-2">
      <label class="field-label">&nbsp;</label>
      <div class="checkbox-wrapper">
        <mat-checkbox
          color="primary"
          [formControl]="incluirAnexoControl"
          [disabled]="disabled"
          [matTooltip]="''"
          matTooltipClass="tooltip-subtipo-custom"
          matTooltipPosition="above"
        >
          Incluir Anexo
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Estado de carga -->
  <div class="loading-integrantes" *ngIf="cargandoIntegrantesAdicionaAnexo">
    <mat-spinner diameter="25"></mat-spinner>
    <span>Cargando integrantes y anexos disponibles...</span>
  </div>

  <!-- Mensaje de error -->
  <div
    class="mensaje-error-anexo"
    *ngIf="errorAdicionaAnexo && !cargandoIntegrantesAdicionaAnexo"
  >
    <mat-icon>warning</mat-icon>
    <span>{{ errorAdicionaAnexo }}</span>
  </div>

  <div
    class="alert alert-info d-flex align-items-start gap-2 mt-2"
    *ngIf="advertenciaAdicionaAnexo && !cargandoIntegrantesAdicionaAnexo"
    role="status"
  >
    <mat-icon>info</mat-icon>
    <span>{{ advertenciaAdicionaAnexo }}</span>
  </div>

  <!-- La tabla principal se reutiliza en la sección de beneficiarios -->
</div>

<ng-container *ngIf="mostrarCamposCambioCobertura && !mostrarCampoColectivo">
  <div class="alert alert-warning" *ngIf="errorTipoPrima">
    <mat-icon>warning</mat-icon>
    <span>{{ errorTipoPrima }}</span>
  </div>

  <div class="loading-tipo-prima" *ngIf="isLoadingTipoPrima">
    <mat-spinner diameter="25"></mat-spinner>
    <span>Consultando configuración de tipo de prima...</span>
  </div>
</ng-container>

<!-- Sección para Traslado a contrato existente -->
<div
  class="campos-traslado-contrato-existente"
  *ngIf="mostrarCamposTrasladoContratoExistente && !mostrarCampoColectivo"
>
  <div class="alert alert-warning" *ngIf="errorTrasladoContratoExistente">
    <mat-icon>warning</mat-icon>
    <span>{{ errorTrasladoContratoExistente }}</span>
  </div>

  <div
    class="loading-traslado-contrato-existente"
    *ngIf="isLoadingTrasladoContratoExistente"
  >
    <mat-spinner diameter="25"></mat-spinner>
    <span>Cargando configuración para traslado a contrato existente...</span>
  </div>

  <div class="form-container" *ngIf="!isLoadingTrasladoContratoExistente">
    <!-- Primera fila: Tipo identificación, Número identificación y Contrato destino -->
    <div class="form-row">
      <div class="col-2">
        <label class="field-label no-wrap-label"
          >Tipo identificación contratante *</label
        >
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select
            [formControl]="tipoIdentificacionContratanteDestinoControl"
            [disabled]="disabled"
            (selectionChange)="
              onTipoIdentificacionContratanteSelected($event.value)
            "
          >
            <mat-option
              *ngFor="let tipo of tiposIdentificacionContratante"
              [value]="tipo"
            >
              {{ tipo.codigo }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              hasFieldError(
                tipoIdentificacionContratanteDestinoControl,
                'required'
              )
            "
          >
            Tipo identificación es obligatorio
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-2">
        <label class="field-label">Número de identificación *</label>
        <mat-form-field
          appearance="outline"
          class="select-field full-width numero-identificacion-contratante-destino"
        >
          <input
            matInput
            [formControl]="numeroIdentificacionContratanteDestinoControl"
            placeholder=""
            [disabled]="disabled"
            (input)="onNumeroIdentificacionChange($event)"
            autocomplete="off"
            inputmode="numeric"
            dir="ltr"
          />
          <mat-error
            *ngIf="
              hasFieldError(
                numeroIdentificacionContratanteDestinoControl,
                'required'
              )
            "
          >
            Número de identificación es obligatorio
          </mat-error>
          <mat-error
            *ngIf="
              hasFieldError(
                numeroIdentificacionContratanteDestinoControl,
                'pattern'
              )
            "
          >
            Solo se permiten números
          </mat-error>
          <mat-error
            *ngIf="
              hasFieldError(
                numeroIdentificacionContratanteDestinoControl,
                'maxlength'
              )
            "
          >
            Máximo 30 dígitos permitidos
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-3">
        <label class="field-label">Contrato destino *</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <mat-select
            [formControl]="contratoDestinoControl"
            [compareWith]="compareContratoDestino"
            placeholder="Seleccione un contrato"
            panelClass="panel-contrato-destino"
            [disabled]="
              disabled ||
              isLoadingContratosDestino ||
              !numeroIdentificacionContratanteDestinoControl.value
            "
            (selectionChange)="onContratoDestinoSelected($event.value)"
          >
            <mat-option *ngIf="isLoadingContratosDestino" disabled>
              Cargando contratos...
            </mat-option>

            <mat-option *ngIf="hasErrorContratosDestino" disabled>
              Error al cargar contratos
            </mat-option>

            <mat-option
              *ngFor="let contrato of contratosDestino$ | async"
              [value]="contrato"
            >
              {{ displayContratoDestino(contrato) }}
            </mat-option>

            <mat-option
              *ngIf="
                (contratosDestino$ | async)?.length === 0 &&
                !isLoadingContratosDestino &&
                !hasErrorContratosDestino &&
                numeroIdentificacionContratanteDestinoControl.value
              "
              disabled
            >
              No se encontró un contrato activo con los datos diligenciados.
              Verifique los datos e intente nuevamente.
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>

          <mat-error *ngIf="hasFieldError(contratoDestinoControl, 'required')">
            Contrato destino es obligatorio
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="col-2">
        <label class="field-label">Corte contrato destino</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <input
            matInput
            [formControl]="corteContratoDestinoControl"
            readonly
          />
        </mat-form-field>
      </div>

      <div class="col-2-5">
        <label class="field-label">Tipo plan destino</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <input
            matInput
            [formControl]="tipoPlanDestinoExistenteControl"
            readonly
          />
        </mat-form-field>
      </div>

      <div class="col-2-5">
        <label class="field-label">Programa destino</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <input
            matInput
            [formControl]="programaDestinoExistenteControl"
            readonly
          />
        </mat-form-field>
      </div>
    </div>

    <!-- Tercera fila: COD. Tarifa destino -->
    <div class="form-row">
      <div class="col-3">
        <label class="field-label">COD. Tarifa destino</label>
        <mat-form-field appearance="outline" class="select-field full-width">
          <input
            matInput
            [formControl]="codTarifaDestinoExistenteControl"
            readonly
          />
        </mat-form-field>
      </div>
      <div class="col-6">
        <!-- Mensaje informativo para contrato colectivo -->
        <div
          class="info-message-colectivo"
          *ngIf="contratoDestinoControl.value?.esColectivo"
        >
          <mat-icon>info</mat-icon>
          <span
            >Si el contrato seleccionado es de tipo plan colectivo o acuerdo
            corporativo, se debe solicitar el Vobo del colectivo como documento
            soporte</span
          >
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-3">
        <label class="field-label">&nbsp;</label>
        <div class="checkbox-wrapper">
          <mat-checkbox
            color="primary"
            [formControl]="incluirAnexoExistenteControl"
            [disabled]="disabled"
            (change)="onIncluirAnexoExistenteChange()"
            [matTooltip]="
              anexosDestinoExistente.length === 0
                ? 'El contrato destino no tiene anexos activos parametrizados'
                : ''
            "
            matTooltipClass="tooltip-subtipo-custom"
            matTooltipPosition="above"
          >
            Incluir Anexo destino
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Sección para Traslado a contrato nuevo -->
<div
  class="campos-traslado-contrato-nuevo"
  *ngIf="mostrarCamposTrasladoContratoNuevo && !mostrarCampoColectivo"
>
  <div class="alert alert-warning" *ngIf="errorTrasladoContrato">
    <mat-icon>warning</mat-icon>
    <span>{{ errorTrasladoContrato }}</span>
  </div>

  <div class="loading-traslado-contrato" *ngIf="isLoadingTrasladoContrato">
    <mat-spinner diameter="25"></mat-spinner>
    <span>Cargando configuración para traslado a contrato nuevo...</span>
  </div>

  <div
    class="form-row"
    *ngIf="!isLoadingTrasladoContrato && !errorTrasladoContrato"
  >
    <div class="col-3">
      <label class="field-label">Tipo Plan destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="tipoPlanDestinoContratoControl"
          [disabled]="disabled"
        >
          <mat-option
            *ngFor="let tipoPlan of tiposPlanesContratoNuevo"
            [value]="tipoPlan"
          >
            {{ tipoPlan.nombre }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="hasFieldError(tipoPlanDestinoContratoControl, 'required')"
        >
          Tipo Plan destino es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3">
      <label class="field-label">Programa destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="programaDestinoContratoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="
            disabled ||
            isLoadingProgramasContrato ||
            !tipoPlanDestinoContratoControl.value
          "
          placeholder="Seleccione programa destino"
        >
          <mat-option disabled class="mat-option-filtro">
            <input
              type="text"
              placeholder="Buscar por código o nombre..."
              style="width: 100%; border: none; outline: none; padding: 4px 0"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (input)="onFiltroProgramaContratoNuevoInput($event)"
            />
          </mat-option>
          <mat-option *ngIf="isLoadingProgramasContrato" disabled>
            Cargando programas...
          </mat-option>
          <mat-option *ngIf="hasErrorProgramasContrato" disabled>
            Error al cargar programas
          </mat-option>
          <ng-container
            *ngIf="programasContratoFiltrados$ | async as programas"
          >
            <mat-option
              *ngFor="let programa of programas; trackBy: trackByProgramaCodigo"
              [value]="programa"
            >
              {{ programa.codigo }} | {{ programa.nombre }}
            </mat-option>
            <mat-option
              *ngIf="
                programas.length === 0 &&
                !isLoadingProgramasContrato &&
                !hasErrorProgramasContrato &&
                tipoPlanDestinoContratoControl.value
              "
              disabled
            >
              No hay programas disponibles
            </mat-option>
          </ng-container>
        </mat-select>
        <button
          mat-icon-button
          matSuffix
          *ngIf="programaDestinoContratoControl.value && !disabled"
          (click)="clearProgramaContratoSelection(); $event.stopPropagation()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-error
          *ngIf="hasFieldError(programaDestinoContratoControl, 'required')"
        >
          Programa destino es obligatorio
        </mat-error>
      </mat-form-field>
      <div class="retry-programas-contrato" *ngIf="hasErrorProgramasContrato">
        <button
          type="button"
          mat-button
          color="primary"
          (click)="retryLoadProgramasContrato()"
        >
          <mat-icon>refresh</mat-icon>
          Reintentar carga de programas
        </button>
      </div>
    </div>

    <div class="col-3-5">
      <label class="field-label">Línea/Subcuenta destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="subcuentaDestinoContratoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="
            disabled ||
            isLoadingSubcuentasContrato ||
            !programaDestinoContratoControl.value
          "
          placeholder="Seleccione línea / subcuenta destino"
        >
          <mat-option *ngIf="isLoadingSubcuentasContrato" disabled>
            Cargando subcuentas...
          </mat-option>
          <ng-container *ngIf="subcuentasContrato$ | async as subcuentas">
            <mat-option disabled class="mat-option-filtro">
              <input
                type="text"
                placeholder="Buscar por código o nombre..."
                style="width: 100%; border: none; outline: none; padding: 4px 0"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                (input)="onFiltroSubcuentaContratoInput($event)"
              />
            </mat-option>
            <mat-option
              *ngFor="
                let subcuenta of filtrarSubcuentasPorTexto(subcuentas, filtroSubcuentaContrato);
                trackBy: trackBySubcuentaCodigo
              "
              [value]="subcuenta"
            >
              {{ subcuenta.codigo }} | {{ subcuenta.nombre }}
            </mat-option>
            <mat-option
              *ngIf="
                subcuentas.length === 0 &&
                !isLoadingSubcuentasContrato &&
                programaDestinoContratoControl.value
              "
              disabled
            >
              No hay subcuentas disponibles
            </mat-option>
          </ng-container>
        </mat-select>
        <button
          mat-icon-button
          matSuffix
          *ngIf="subcuentaDestinoContratoControl.value && !disabled"
          (click)="clearSubcuentaContratoSelection(); $event.stopPropagation()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-error
          *ngIf="hasFieldError(subcuentaDestinoContratoControl, 'required')"
        >
          Línea/Subcuenta destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div
    class="form-row"
    *ngIf="!isLoadingTrasladoContrato && !errorTrasladoContrato"
  >
    <div class="col-2-5">
      <label class="field-label">Corte destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="corteDestinoContratoControl"
          [disabled]="
            disabled ||
            !subcuentaDestinoContratoControl.value ||
            isCorteDestinoReadonly
          "
        >
          <mat-option
            *ngFor="let corte of cortesDestinoContrato"
            [value]="corte.corte"
          >
            {{ corte.corte }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="hasFieldError(corteDestinoContratoControl, 'required')"
        >
          Corte destino es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <!-- <div class="col-3">
      <label class="field-label">Tarifa destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="tarifaDestinoContratoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="
            disabled ||
            isLoadingTarifasContrato ||
            !corteDestinoContratoControl.value
          "
          panelClass="panel-tarifa-contrato"
          placeholder="Seleccione tarifa destino"
        >
          <mat-option *ngIf="isLoadingTarifasContrato" disabled>
            Cargando tarifas...
          </mat-option>
          <mat-option *ngIf="hasErrorTarifasContrato" disabled>
            No hay tarifas disponibles para esta configuración
          </mat-option>
          <ng-container *ngIf="tarifasContrato$ | async as tarifas">
            <mat-option
              *ngFor="let tarifa of tarifas; trackBy: trackByTarifaCodigo"
              [value]="tarifa"
            >
              {{ tarifa.codigo }} | {{ tarifa.descripcion }}
            </mat-option>
            <mat-option
              *ngIf="
                tarifas.length === 0 &&
                !isLoadingTarifasContrato &&
                !hasErrorTarifasContrato &&
                corteDestinoContratoControl.value
              "
              disabled
            >
              No se encontraron tarifas
            </mat-option>
          </ng-container>
        </mat-select>
        <button
          mat-icon-button
          matSuffix
          *ngIf="tarifaDestinoContratoControl.value && !disabled"
          (click)="clearTarifaContratoSelection(); $event.stopPropagation()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-error
          *ngIf="hasFieldError(tarifaDestinoContratoControl, 'required')"
        >
          Tarifa destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div> -->

    <div class="col-3">
      <label class="field-label">Tarifa destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="tarifaDestinoContratoControl"
          [compareWith]="compareByCodigoOrId"
          [disabled]="
            disabled ||
            isLoadingTarifasContrato ||
            !corteDestinoContratoControl.value
          "
          panelClass="panel-tarifa-contrato"
          placeholder="Seleccione tarifa destino"
        >
          <mat-option disabled class="mat-option-filtro">
            <input
              type="text"
              placeholder="Buscar por código o nombre..."
              style="width: 100%; border: none; outline: none; padding: 4px 0"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (input)="onFiltroTarifaDestinoContratoInput($event)"
            />
          </mat-option>
          <mat-option *ngIf="isLoadingTarifasContrato" disabled>
            Cargando tarifas...
          </mat-option>
          <mat-option *ngIf="hasErrorTarifasContrato" disabled>
            No hay tarifas disponibles para esta configuración
          </mat-option>
          <mat-option
            *ngFor="
              let tarifa of tarifasDestinoContratoFiltradasBusqueda;
              trackBy: trackByTarifaCodigo
            "
            [value]="tarifa"
          >
            {{ tarifa.codigo }} | {{ tarifa.descripcion }}
          </mat-option>
          <mat-option
            *ngIf="
              tarifasDestinoContratoFiltradasBusqueda.length === 0 &&
              !isLoadingTarifasContrato &&
              !hasErrorTarifasContrato &&
              corteDestinoContratoControl.value
            "
            disabled
          >
            No se encontraron tarifas
          </mat-option>
        </mat-select>
        <button
          mat-icon-button
          matSuffix
          *ngIf="tarifaDestinoContratoControl.value && !disabled"
          (click)="clearTarifaContratoSelection(); $event.stopPropagation()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-error
          *ngIf="hasFieldError(tarifaDestinoContratoControl, 'required')"
        >
          Tarifa destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3-5">
      <label class="field-label">Sucursal comercializable destino *</label>
      <mat-form-field appearance="outline" class="select-field full-width">
        <mat-select
          [formControl]="sucursalComercializableContratoControl"
          [disabled]="disabled || isSucursalComercializableReadonly"
          (selectionChange)="
            onSucursalComercializableContratoSelected($event.value)
          "
        >
          <mat-option
            *ngFor="let sucursal of sucursalesComercializablesContrato"
            [value]="sucursal"
          >
            {{ sucursal.codigo }} - {{ sucursal.nombre }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            hasFieldError(sucursalComercializableContratoControl, 'required')
          "
        >
          Sucursal comercializable destino es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div
    class="form-row"
    *ngIf="!isLoadingTrasladoContrato && !errorTrasladoContrato"
  >
    <div class="col-3">
      <label class="field-label">&nbsp;</label>
      <div class="checkbox-wrapper">
        <mat-checkbox
          color="primary"
          [formControl]="incluirAnexoControl"
          [disabled]="disabled"
          [matTooltip]="
            incluirAnexoControl.disabled
              ? 'Seleccione tipo de plan, programa y demás datos destino; luego podrá marcar incluir anexo'
              : ''
          "
          matTooltipClass="tooltip-subtipo-custom"
          matTooltipPosition="above"
        >
          Incluir Anexo
        </mat-checkbox>
      </div>
    </div>

    <div class="col-3-5"></div>
  </div>
</div>

<div *ngIf="mostrarTablaIntegrantesTrasladoExistente">
  <div class="loading-integrantes" *ngIf="cargandoBeneficiarios">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Cargando información de integrantes...</span>
  </div>

  <div class="alert alert-error" *ngIf="errorValidacionIntegrantes">
    <mat-icon>error</mat-icon>
    <span>{{ errorValidacionIntegrantes }}</span>
  </div>

  <div
    class="contenido-tabla"
    *ngIf="!cargandoBeneficiarios && integrantesTrasladoExistente.length > 0"
  >
    <!-- Reutilizar la estructura de tabla existente `tabla-tarifas` para Traslado a Contrato Existente -->
    <table class="tabla-tarifas tabla-integrantes-contrato">
      <thead>
        <tr>
          <th>No.</th>
          <th>Identificación</th>
          <th>Nombre usuario</th>
          <th>Parentesco destino *</th>
          <th *ngIf="esTipoTrasladoContratoExistenteActivo()">Contrato</th>
          <th>Edad</th>
          <th>Género</th>
          <th>Anexo destino</th>
          <th>Valor tarifa Anexo</th>
          <th>Valor tarifa Programa</th>
          <th>Total tarifa</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let integrante of integrantesTrasladoExistente; let i = index"
          [ngClass]="{
            'fila-titular-contrato-destino':
              integrante.esTitularContratoDestino,
            'fila-integrante-paso1': !integrante.esTitularContratoDestino,
          }"
        >
          <td>{{ i + 1 }}</td>
          <td>
            {{ integrante.tipoDocumento }} - {{ integrante.numeroDocumento }}
          </td>
          <td>{{ integrante.nombreCompleto }}</td>
          <td class="parentesco-cell">
            <mat-select
              [(value)]="integrante.parentescoDestino"
              [disabled]="disabled"
              placeholder="Seleccionar parentesco"
              (selectionChange)="
                onParentescoDestinoExistenteChange(i, $event.value)
              "
              [compareWith]="compareParentesco"
              required
            >
              <mat-option
                *ngFor="let parentesco of parentescosActivos"
                [value]="parentesco"
              >
                {{ parentesco.nombre }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                !integrante.parentescoDestino && integrante.showParentescoError
              "
            >
              Parentesco destino es obligatorio
            </mat-error>
          </td>
          <td *ngIf="esTipoTrasladoContratoExistenteActivo()">
            {{
              integrante.esContratoDestino
                ? "Contrato destino"
                : "Contrato origen"
            }}
          </td>
          <td>{{ integrante.edad }}</td>
          <td>{{ integrante.genero }}</td>
          <td class="anexo-cell">
            <mat-form-field appearance="outline" class="anexo-field">
              <mat-select
                [(value)]="integrante.anexoDestino"
                [disabled]="
                  disabled ||
                  !incluirAnexoExistenteControl.value ||
                  integrante.anexoDestinoHabilitado === false
                "
                placeholder="Seleccionar anexo"
                [matTooltip]="
                  !incluirAnexoExistenteControl.value
                    ? 'No se habilitan los campos de anexo si la caja de verificación incluir Anexo no está activada'
                    : integrante.anexoDestinoHabilitado === false
                      ? 'Este integrante no cumple condiciones para anexo'
                      : ''
                "
                matTooltipClass="tooltip-subtipo-custom"
                matTooltipPosition="above"
                (selectionChange)="onAnexoExistenteChange(i, $event.value)"
              >
                <mat-option value="">Ninguno</mat-option>
                <mat-option
                  *ngFor="
                    let anexo of integrante.anexosDisponibles ||
                      anexosDestinoExistente
                  "
                  [value]="anexo.codigo"
                >
                  {{ anexo.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td class="valor-tarifa">
            {{
              integrante.valorTarifaAnexo
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="valor-tarifa">
            {{
              integrante.valorTarifaPrograma
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="total-tarifa">
            {{
              integrante.totalTarifa
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="fila-total-cuota">
          <td [attr.colspan]="numeroColumnasTabla" class="total-cuota-celda">
            <strong>
              <span>Total cuota + IVA</span>
              <span class="total-cuota__amount">{{
                totalCuotaIvaTrasladoExistente
                  | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
              }}</span>
            </strong>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div
    class="no-integrantes"
    *ngIf="!cargandoBeneficiarios && integrantesTrasladoExistente.length === 0"
  >
    <mat-icon>info</mat-icon>
    <span>No hay integrantes para mostrar.</span>
  </div>
</div>
<div
  class="tabla-integrantes-contrato-nuevo"
  *ngIf="mostrarTablaIntegrantesContratoNuevo"
>
  <div class="loading-integrantes" *ngIf="cargandoIntegrantesContrato">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Cargando información de integrantes...</span>
  </div>

  <div class="alert alert-error" *ngIf="errorValidacionIntegrantes">
    <mat-icon>error</mat-icon>
    <span>{{ errorValidacionIntegrantes }}</span>
  </div>

  <div
    class="contenido-tabla"
    *ngIf="!cargandoIntegrantesContrato && integrantesContratoNuevo.length > 0"
  >
    <table class="tabla-integrantes-contrato">
      <thead>
        <tr>
          <th>No.</th>
          <th>Identificación</th>
          <th>Nombre usuario</th>
          <th>Parentesco destino *</th>
          <th>Edad</th>
          <th>Género</th>
          <th>Anexo destino</th>
          <th>Valor tarifa Anexo</th>
          <th>Valor tarifa Programa</th>
          <th>Total tarifa</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let integrante of integrantesContratoNuevo; let i = index"
          [ngClass]="{
            'fila-integrante-destino':
              integrante.origenLista === 'contrato_destino',
            'fila-integrante-paso1': integrante.origenLista === 'paso_1',
          }"
        >
          <td>{{ i + 1 }}</td>
          <td>
            {{ integrante.tipoDocumento }} - {{ integrante.numeroDocumento }}
          </td>
          <td>{{ integrante.nombreCompleto }}</td>
          <td class="parentesco-cell">
            <mat-select
              [(value)]="integrante.parentescoDestino"
              [disabled]="disabled"
              placeholder="Seleccionar parentesco"
              (selectionChange)="
                onParentescoDestinoContratoNuevoChange(i, $event.value)
              "
              [compareWith]="compareParentesco"
              required
            >
              <mat-option
                *ngFor="let parentesco of parentescosActivos"
                [value]="parentesco"
              >
                {{ parentesco.nombre }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                !integrante.parentescoDestino && integrante.showParentescoError
              "
            >
              Parentesco destino es obligatorio
            </mat-error>
          </td>
          <td>{{ integrante.edad }}</td>
          <td>{{ integrante.genero }}</td>
          <td class="anexo-cell">
            <mat-form-field appearance="outline" class="anexo-field">
              <mat-select
                [(value)]="integrante.anexoDestino"
                [disabled]="disabled || !getIncluirAnexoContratoValue()"
                placeholder="Seleccionar anexo"
                [matTooltip]="
                  !getIncluirAnexoContratoValue()
                    ? 'No se habilitan los campos de anexo si la caja de verificación incluir Anexo no está activada'
                    : ''
                "
                matTooltipClass="tooltip-subtipo-custom"
                matTooltipPosition="above"
                (selectionChange)="onAnexoDestinoChange(i, $event.value)"
              >
                <mat-option value="">Ninguno</mat-option>
                <mat-option
                  *ngFor="let anexo of anexosDestinoContrato"
                  [value]="anexo.codigo"
                >
                  {{ anexo.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td class="valor-tarifa">
            {{
              integrante.valorTarifaAnexo
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="valor-tarifa">
            {{
              integrante.valorTarifaPrograma
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="total-tarifa">
            {{
              integrante.totalTarifa
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="total-cuota">
      <strong>
        <span>Total cuota + IVA</span>
        <span class="total-cuota__amount">{{
          totalCuotaIvaContratoNuevo
            | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
        }}</span>
      </strong>
    </div>
  </div>

  <div
    class="no-integrantes"
    *ngIf="
      !cargandoIntegrantesContrato && integrantesContratoNuevo.length === 0
    "
  >
    <mat-icon>info</mat-icon>
    <span
      >No hay integrantes para mostrar. Revise el contrato consultado en el paso
      1 o la respuesta del servicio de información del contrato
      (info-contrato-user).</span
    >
  </div>
</div>

<div
  class="seccion-contratante-destino"
  *ngIf="
    (mostrarTablaIntegrantesContratoNuevo &&
      integrantesContratoNuevo.length > 0) ||
    mostrarCambioResponsablePagador
  "
>
  <h3 class="titulo-seccion">
    {{
      mostrarCambioResponsablePagador
        ? "DATOS DEL NUEVO RESPONSABLE PAGADOR"
        : "INFORMACIÓN DEL CONTRATANTE DESTINO"
    }}
  </h3>

  <div class="grupo-opciones" *ngIf="!mostrarCambioResponsablePagador">
    <mat-radio-group
      [formControl]="tipoContratanteControl"
      (change)="onTipoContratanteChange($event.value)"
    >
      <mat-radio-button value="mantener" class="opcion-radio">
        Mantener contratante actual
      </mat-radio-button>
      <mat-radio-button value="cambiar" class="opcion-radio">
        Cambio de contratante
      </mat-radio-button>
    </mat-radio-group>

    <div class="checkbox-cambio-datos">
      <mat-checkbox
        [formControl]="cambiarDatosContratanteControl"
        (change)="onCambioDatosContratanteChange()"
        [disabled]="!puedeEditarDatosContratante"
        [matTooltip]="
          !puedeEditarDatosContratante
            ? 'Habilitar cuando se precarguen los datos del contratante'
            : ''
        "
        matTooltipPosition="above"
        color="primary"
      >
        Cambio de datos del contratante
      </mat-checkbox>
    </div>
  </div>

  <div class="row filas-contratante-destino">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Código de Asesor *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [formControl]="codigoAsesorDestinoControl"
          [readonly]="!puedeEditarCodigoAsesor"
        />
        <mat-error
          *ngIf="hasFieldError(codigoAsesorDestinoControl, 'required')"
        >
          Código de asesor es obligatorio
        </mat-error>
        <mat-error
          *ngIf="hasFieldError(codigoAsesorDestinoControl, 'inexistente')"
        >
          Asesor inexistente
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Tipo documento *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="tipoDocumentoContratanteControl">
          <mat-option
            *ngFor="let tipo of tiposDocumentoContratante"
            [value]="tipo.codigo"
          >
            {{ tipo.codigo }} - {{ tipo.tipo_documento }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="hasFieldError(tipoDocumentoContratanteControl, 'required')"
        >
          Tipo documento es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Número documento *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [formControl]="numeroDocumentoContratanteControl"
          inputmode="numeric"
          (input)="soloNumeros($event)"
        />
        <mat-icon
          matSuffix
          class="search-icon"
          *ngIf="tipoContratanteControl.value === 'cambiar'"
          (click)="buscarContratante()"
          >search</mat-icon
        >
        <mat-error
          *ngIf="hasFieldError(numeroDocumentoContratanteControl, 'required')"
        >
          Número documento es obligatorio
        </mat-error>
        <mat-error
          *ngIf="
            hasFieldError(numeroDocumentoContratanteControl, 'noIntegrante')
          "
        >
          Debe indicar el tipo y número de documento de algún integrante del
          contrato actual
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Primer Apellido *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [formControl]="primerApellidoContratanteControl" />
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Segundo Apellido</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [formControl]="segundoApellidoContratanteControl" />
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Primer Nombre *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [formControl]="primerNombreContratanteControl" />
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Segundo Nombre</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [formControl]="segundoNombreContratanteControl" />
      </mat-form-field>
    </div>

    <!-- Segunda fila: 6 campos - Fecha nacimiento, Estado civil, Género, Estrato social, Nacionalidad, Profesión -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Fecha de nacimiento *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [matDatepicker]="pickerNacimiento"
          [formControl]="fechaNacimientoContratanteControl"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerNacimiento"
          [disabled]="true"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerNacimiento disabled="true"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Estado civil *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="estadoCivilContratanteControl">
          <mat-option
            *ngFor="let estado of estadosCiviles"
            [value]="estado.civil_esta"
          >
            {{ estado.deno }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="estadoCivilContratanteControl.hasError('required')">
          Estado civil es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Género *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="generoContratanteControl">
          <mat-option
            *ngFor="let genero of generos"
            [value]="genero.Codigo ?? genero.codigo"
          >
            {{ genero.Nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Estrato social *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="estratoSocialContratanteControl">
          <mat-option
            *ngFor="let estrato of estratosSociales"
            [value]="estrato.estrato_social"
          >
            {{ estrato.deno }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="estratoSocialContratanteControl.hasError('required')">
          Estrato social es obligatorio
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <label class="field-label">Nacionalidad *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select
          [formControl]="nacionalidadContratanteControl"
        >
          <mat-option
            *ngFor="let nacionalidad of nacionalidades"
            [value]="nacionalidad.nacio"
          >
            {{ nacionalidad.denominacion }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="nacionalidadContratanteControl.hasError('required')">
          Nacionalidad es obligatoria
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
      <label class="field-label">Profesión *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [formControl]="profesionContratanteControl">
          <mat-option
            *ngFor="let profesion of profesiones"
            [value]="profesion.profesion"
          >
            {{ profesion.deno }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="profesionContratanteControl.hasError('required')">
          Profesión es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
    <!-- Tercera fila: 3 campos - ¿Desea recibir correspondencia?, Email, Ocupación -->
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
      <label class="field-label"
        >¿Desea recibir la correspondencia física? *</label
      >
      <mat-form-field appearance="outline" class="full-width">
        <mat-select
          [formControl]="recibirCorrespondenciaControl"
        >
          <mat-option value="Si">Si</mat-option>
          <mat-option value="No">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
      <label class="field-label">Email *</label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [formControl]="emailContratanteControl"
          type="email"
        />
        <mat-error *ngIf="hasFieldError(emailContratanteControl, 'required')">
          Email es obligatorio
        </mat-error>
        <mat-error *ngIf="hasFieldError(emailContratanteControl, 'email')">
          Formato de correo inválido
        </mat-error>
        <mat-error
          *ngIf="emailContratanteControl.hasError('afilmedValidation')"
        >
          {{ emailContratanteControl.getError("afilmedValidation").message }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
      <label class="field-label">Ocupación *</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select
          [formControl]="ocupacionContratanteControl"
        >
          <mat-option
            *ngFor="let ocupacion of ocupaciones"
            [value]="ocupacion.ocupacion"
          >
            {{ ocupacion.deno }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="ocupacionContratanteControl.hasError('required')">
          Ocupación es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
    <!-- Dirección de residencia (mock: recuadro destacado) -->
    <div class="col-12 subseccion-direccion-contratante">
      <h4 class="subtitulo-direccion-contratante">Dirección de residencia *</h4>
      <div class="row g-4 filas-direccion-contratante">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Tipo vía *</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select
              [formControl]="tipoViaControl"
            >
              <mat-option
                *ngFor="let tipoVia of tiposVia"
                [value]="tipoVia.codigo"
              >
                {{ tipoVia.codigo }} - {{ tipoVia.nombre }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="tipoViaControl.hasError('required')">
              Tipo vía es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Número</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="numeroViaControl"
              type="text"
              inputmode="numeric"
              (input)="soloNumeros($event)"
            />
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Número de Placa</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="numeroPlacaControl"
            />
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Dirección *</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="direccionControl"
            />
            <mat-error *ngIf="direccionControl.hasError('required')">
              Dirección es obligatoria
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Complemento</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="complementoDireccionControl"
            />
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <label class="field-label">Barrio *</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select
              [formControl]="barrioControl"
            >
              <mat-option
                *ngFor="let barrio of barrios"
                [value]="barrio.codigo"
              >
                {{ barrio.codigo }} - {{ barrio.nombre }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="barrioControl.hasError('required')">
              Barrio es obligatorio
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Quinta fila: 4 campos - Departamento, Municipio, Teléfono, Celular -->
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <label class="field-label">Departamento correspondencia *</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select
              [formControl]="departamentoControl"
              (selectionChange)="onDepartamentoChange($event.value)"
            >
              <mat-option
                *ngFor="let departamento of departamentos"
                [value]="departamento.codigo"
              >
                {{ departamento.codigo }} - {{ departamento.nombre }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="departamentoControl.hasError('required')">
              Departamento es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <label class="field-label">Municipio correspondencia *</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select
              [formControl]="municipioControl"
            >
              <mat-option
                *ngFor="let municipio of municipios"
                [value]="municipio.codigo"
              >
                {{ municipio.codigo }} - {{ municipio.nombre }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="municipioControl.hasError('required')">
              Municipio es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <label class="field-label">Teléfono de Residencia</label>
          <!-- <label class="field-label">Teléfono de Residencia *</label> -->
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="telefonoResidenciaControl"
              type="tel"
              inputmode="numeric"
              (input)="soloNumeros($event)"
            />
            <mat-error *ngIf="telefonoResidenciaControl.hasError('required')">
              Teléfono es obligatorio
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <label class="field-label">Celular *</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              [formControl]="celularControl"
              type="tel"
              inputmode="numeric"
              (input)="soloNumeros($event)"
            />
            <mat-error *ngIf="celularControl.hasError('required')">
              Celular es obligatorio
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- Botón de actualización -->
  <div class="form-row fila-boton-actualizar-afilmed">
    <div
      class="col-12"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
      "
    >
      <button
        mat-raised-button
        color="primary"
        class="btn-actualizar-afilmed"
        [disabled]="!puedeActualizarAfilmed || isLoadingActualizacionAfilmed"
        (click)="actualizarDatosAfilmed()"
      >
        <mat-spinner
          *ngIf="isLoadingActualizacionAfilmed"
          diameter="20"
          style="margin-right: 8px"
        ></mat-spinner>
        {{
          isLoadingActualizacionAfilmed
            ? "Actualizando..."
            : "Actualizar los datos en Afilmed"
        }}
      </button>

      <!-- Mensaje informativo cuando el botón está deshabilitado -->
      <div
        *ngIf="
          !puedeActualizarAfilmed &&
          !isLoadingActualizacionAfilmed &&
          tipoContratanteControl.value &&
          cambiarDatosContratanteControl.value
        "
        class="mensaje-boton-deshabilitado"
      >
        <mat-icon>info</mat-icon>
        <span
          >El botón se habilitará cuando modifique algún campo editable</span
        >
      </div>
    </div>
  </div>
</div>

<div
  class="tabla-beneficiarios"
  [ngClass]="{
    'tabla-beneficiarios--adiciona-anexo': esAdicionaAnexoSeleccionado(),
  }"
  *ngIf="
    ((mostrarTablaBeneficiarios ||
      (esCambioPlanTipoSeleccionado() && mostrarCamposTrasladoContratoNuevo)) &&
      !mostrarTablaIntegrantesContratoNuevo &&
      !mostrarCamposTrasladoContratoExistente &&
      !mostrarTablaIntegrantesTrasladoExistente) ||
    (esAdicionaAnexoSeleccionado() && mostrarTablaAdicionaAnexo)
  "
>
  <div
    class="loading-beneficiarios"
    *ngIf="!esAdicionaAnexoSeleccionado() && cargandoBeneficiarios"
  >
    <mat-spinner diameter="20"></mat-spinner>
    <span>Cargando información de beneficiarios...</span>
  </div>

  <div
    class="alert alert-warning mt-2"
    *ngIf="
      advertenciaIntegrantesCambioCobertura && !esAdicionaAnexoSeleccionado()
    "
    role="status"
  >
    <span>{{ advertenciaIntegrantesCambioCobertura }}</span>
  </div>

  <div
    class="contenido-tabla"
    [ngClass]="{
      'contenido-tabla--adiciona-anexo': esAdicionaAnexoSeleccionado(),
    }"
    *ngIf="
      esAdicionaAnexoSeleccionado()
        ? integrantesAdicionaAnexo.length > 0
        : !cargandoBeneficiarios &&
          (beneficiariosTarifa.length > 0 ||
            (esCambioPlanTipoSeleccionado() &&
              mostrarCamposTrasladoContratoNuevo))
    "
  >
    <table
      class="tabla-tarifas"
      [ngClass]="{
        'tabla-tarifas--adiciona-anexo': esAdicionaAnexoSeleccionado(),
      }"
    >
      <thead>
        <tr>
          <th>No.</th>
          <th>Identificación</th>
          <th>Nombre usuario</th>
          <th *ngIf="!esAdicionaAnexoSeleccionado()">
            <ng-container
              *ngIf="esCambioPlanTipoSeleccionado(); else parentescoNormal"
            >
              Parentesco destino
            </ng-container>
            <ng-template #parentescoNormal> Parentesco </ng-template>
          </th>
          <th *ngIf="!esAdicionaAnexoSeleccionado()">Edad</th>
          <th *ngIf="!esAdicionaAnexoSeleccionado()">Género</th>
          <th>Anexo destino</th>
          <th>Valor tarifa Anexo</th>
          <th>Valor tarifa Programa</th>
          <th>Total tarifa</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngIf="
            (esCambioPlanTipoSeleccionado() ||
              !esAdicionaAnexoSeleccionado()) &&
            beneficiariosTarifa.length === 0
          "
        >
          <td colspan="10" class="tabla-beneficiarios-vacio">
            No hay integrantes cargados. Revise el paso 1 (info-contrato-user) o
            reintente cargando de nuevo la tarifa destino.
          </td>
        </tr>
        <tr
          *ngFor="
            let fila of esAdicionaAnexoSeleccionado() &&
            !esCambioPlanTipoSeleccionado()
              ? integrantesAdicionaAnexo
              : beneficiariosTarifa;
            let idx = index;
            trackBy: trackByFilaTabla
          "
        >
          <td>{{ fila.numero }}</td>
          <td>{{ fila.identificacion }}</td>
          <td>{{ fila.nombreUsuario }}</td>
          <td *ngIf="!esAdicionaAnexoSeleccionado()" class="parentesco-cell">
            <mat-select
              *ngIf="esCambioPlanTipoSeleccionado()"
              [(value)]="fila.parentescoDestino"
              [disabled]="disabled"
              placeholder="Seleccionar parentesco"
              (selectionChange)="onParentescoDestinoChange(fila, $event.value)"
            >
              <mat-option
                *ngIf="
                  fila.parentescoDestino &&
                  !parentescoCodigoEnCatalogo(fila.parentescoDestino)
                "
                [value]="fila.parentescoDestino"
              >
                {{ fila.parentesco || fila.parentescoDestino }}
              </mat-option>
              <mat-option
                *ngFor="let parentesco of parentescosActivos"
                [value]="parentesco.codigo"
              >
                {{ parentesco.nombre }}
              </mat-option>
            </mat-select>
            <span *ngIf="!esCambioPlanTipoSeleccionado()">{{
              fila.parentesco
            }}</span>
          </td>
          <td *ngIf="!esAdicionaAnexoSeleccionado()">{{ fila.edad }}</td>
          <td *ngIf="!esAdicionaAnexoSeleccionado()">{{ fila.genero }}</td>
          <td class="anexo-cell">
            <ng-container
              *ngIf="esAdicionaAnexoSeleccionado(); else anexoPorTipo"
            >
              <ng-container *ngIf="fila.campoHabilitado; else anexoNoAplica">
                <mat-form-field appearance="outline" class="anexo-field">
                  <mat-select
                    multiple
                    [value]="fila.anexoDestino"
                    (selectionChange)="
                      onAnexoDestinoSelected(fila, $event.value)
                    "
                    [disabled]="disabled || isLoadingAnexos"
                    panelClass="panel-anexo-destino"
                    placeholder="Seleccionar anexo"
                  >
                    <ng-container *ngFor="let anexo of fila.anexosHabilitados">
                      <mat-option
                        *ngIf="anexo.codigo !== 'NO_APLICA'"
                        [value]="anexo"
                      >
                        {{ anexo.codigoFormato || anexo.codigo }} -
                        {{ anexo.nombre }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-error *ngIf="fila.anexoDestino.length === 0">
                    Debe seleccionar al menos un anexo
                  </mat-error>
                </mat-form-field>
              </ng-container>
              <ng-template #anexoNoAplica>
                <mat-form-field appearance="outline" class="anexo-field">
                  <mat-select
                    [disabled]="true"
                    placeholder="Seleccionar anexo"
                    [matTooltip]="
                      'Sin opciones de anexo para este integrante según la consulta.'
                    "
                    matTooltipPosition="above"
                  >
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </ng-container>
            <ng-template #anexoPorTipo>
              <ng-container
                *ngIf="esCambioPlanTipoSeleccionado(); else anexoGenerico"
              >
                <mat-form-field appearance="outline" class="anexo-field">
                  <mat-select
                    multiple
                    [(value)]="fila.anexoDestino"
                    (selectionChange)="
                      onAnexoDestinoTipo5Selected(fila, $event.value)
                    "
                    [disabled]="
                      disabled ||
                      !getIncluirAnexoValue() ||
                      fila.anexoDestinoHabilitado === false
                    "
                    placeholder="Seleccionar anexo"
                  >
                    <mat-option
                      *ngFor="let anexo of fila.anexosHabilitados || []"
                      [value]="anexo.codigo"
                    >
                      {{ anexo.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </ng-template>
            <ng-template #anexoGenerico>
              <ng-container
                *ngIf="
                  anexoGenericoSinOpcionesElegibles(fila);
                  else anexoGenericoEditable
                "
              >
                <mat-form-field appearance="outline" class="anexo-field">
                  <mat-select
                    [disabled]="true"
                    placeholder="Seleccionar anexo"
                    [matTooltip]="
                      'Sin opciones de anexo para este integrante según la consulta.'
                    "
                    matTooltipPosition="above"
                  >
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #anexoGenericoEditable>
                <mat-form-field appearance="outline" class="anexo-field">
                  <mat-select
                    [disabled]="
                      disabled ||
                      !getIncluirAnexoValue() ||
                      fila.anexoDestinoHabilitado === false
                    "
                    [(value)]="fila.anexoDestino"
                    placeholder="Seleccionar anexo"
                    [matTooltip]="
                      !getIncluirAnexoValue()
                        ? 'No se habilitan los campos de anexo si la caja de verificación incluir Anexo no está activada'
                        : fila.anexoDestinoHabilitado === false
                          ? 'Sin opciones de anexo para este integrante según la consulta.'
                          : ''
                    "
                    matTooltipClass="tooltip-subtipo-custom"
                    matTooltipPosition="above"
                  >
                    <mat-option
                      *ngIf="anexoGenericoIncluyeNinguno(fila)"
                      value=""
                      >Ninguno</mat-option
                    >
                    <mat-option
                      *ngFor="let anexo of opcionesAnexoDestinoGenerico(fila)"
                      [value]="anexo.codigo"
                    >
                      {{ anexo.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </ng-template>
          </td>
          <td class="valor-tarifa">
            {{
              fila.valorTarifaAnexo
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="valor-tarifa">
            {{
              fila.valorTarifaPrograma
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
          <td class="total-tarifa">
            {{
              fila.totalTarifa
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="fila-total-cuota" *ngIf="esAdicionaAnexoSeleccionado()">
          <td
            [attr.colspan]="numeroColumnasTablaBeneficiarios"
            class="total-cuota-anexo"
          >
            <span class="total-cuota-anexo__label">Total cuota + IVA</span>
            <span class="total-cuota-anexo__amount">{{
              totalCuotaIvaAdicionaAnexo
                | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
            }}</span>
          </td>
        </tr>
        <tr class="fila-total-cuota" *ngIf="!esAdicionaAnexoSeleccionado()">
          <td
            [attr.colspan]="numeroColumnasTablaBeneficiarios"
            class="total-cuota"
          >
            <strong>
              <span>Total cuota + IVA</span>
              <span class="total-cuota__amount">{{
                totalCuotaIva
                  | currency: "COP" : "symbol-narrow" : "1.2-2" : "es-CO"
              }}</span>
            </strong>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div
    class="no-integrantes"
    *ngIf="
      !esAdicionaAnexoSeleccionado() &&
      !cargandoBeneficiarios &&
      beneficiariosTarifa.length === 0
    "
  >
    <mat-icon>info</mat-icon>
    <span
      >No hay integrantes seleccionados para incluir en la novedad de
      traslado.</span
    >
  </div>
</div>

<div
  class="seccion-cambio-titular"
  *ngIf="mostrarCambioTitular || mostrarCambioResponsablePagador"
>
  <div class="seccion-contratante-destino-titular">
    <h3 class="titulo-seccion">
      {{
        mostrarCambioResponsablePagador
          ? "INFORMACIÓN DEL RESPONSABLE PAGADOR ACTUAL"
          : "INFORMACIÓN DEL TITULAR ACTUAL"
      }}
    </h3>

    <p class="mensaje-informativo-cambio-titular">
      <mat-icon>info</mat-icon>
      <span>{{
        mostrarCambioResponsablePagador
          ? "El cambio de responsable pagador se registra en la solicitud de traslado."
          : "El cambio de titularidad la realiza operaciones al gestionar la solicitud de traslado."
      }}</span>
    </p>

    <div
      class="cambio-titular-alerta"
      *ngIf="
        mostrarCambioResponsablePagador &&
        advertenciaDebitoActualCambioResponsable
      "
      role="alert"
    >
      <mat-icon>info</mat-icon>
      <span>{{ advertenciaDebitoActualCambioResponsable }}</span>
    </div>

    <div
      class="cambio-titular-alerta error-message"
      *ngIf="cambioTitularMensajeAlerta"
      role="alert"
    >
      <mat-icon>warning</mat-icon>
      <span>{{ cambioTitularMensajeAlerta }}</span>
    </div>

    <div class="form-grid-titular">
      <div>
        <label class="field-label no-wrap-label">Tipo de identificación</label>
        <mat-form-field appearance="outline" class="titular-actual-readonly">
          <input
            matInput
            [value]="titularActualVista?.tipoTexto ?? ''"
            readonly
            tabindex="-1"
          />
        </mat-form-field>
      </div>

      <div>
        <label class="field-label">Número de identificación</label>
        <mat-form-field appearance="outline" class="titular-actual-readonly">
          <input
            matInput
            [value]="titularActualVista?.numeroTexto ?? ''"
            readonly
            tabindex="-1"
          />
        </mat-form-field>
      </div>

      <div>
        <label class="field-label">{{
          mostrarCambioResponsablePagador
            ? "Nombres y apellidos"
            : "Nombre del titular actual"
        }}</label>
        <mat-form-field appearance="outline" class="titular-actual-readonly">
          <input
            matInput
            [value]="titularActualVista?.nombreCompleto ?? ''"
            readonly
            tabindex="-1"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row" *ngIf="mostrarCambioResponsablePagador">
      <div class="col-12 col-md-4">
        <label class="field-label">Fecha de aplicación del retiro *</label>
        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            [matDatepicker]="pickerFechaRetiroResponsable"
            [formControl]="fechaAplicacionNovedadControl"
            [disabled]="disabled"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerFechaRetiroResponsable"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerFechaRetiroResponsable></mat-datepicker>
          <mat-hint
            >Fecha en que comienza a aplicar el retiro del responsable pagador
            actual.</mat-hint
          >
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <label class="field-label">Motivo de retiro *</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select
            [formControl]="motivoRetiroResponsableControl"
            [disabled]="disabled"
          >
            <mat-option
              *ngFor="let m of motivosRetiroResponsable"
              [value]="m.codigo"
            >
              {{ m.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

    <div class="seccion-nuevo-titular">
     <div class="titulo-con-icono">
        <h3 class="titulo-seccion">
          {{
            mostrarCambioResponsablePagador
              ? "SELECCIÓN DE NUEVOS PARENTESCOS"
              : "SELECCIÓN DEL NUEVO TITULAR"
          }}
        </h3>

        <div
          *ngIf="mostrarCambioResponsablePagador"
          class="icon-area"
          [ngbTooltip]="
            'Seleccione el parentesco de cada integrante respecto al nuevo responsable de pago.'
          "
          tooltipClass="tooltip-custom"
          placement="right"
        >
            <img
              src="assets/imagenes/info-icon.png"
              width="20"
              height="20"
              alt="icon info"
            />
        </div>
      </div>

    <div class="tabla-integrantes" *ngIf="integrantesSinTitular.length > 0">
      <table class="integrantes-table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Identificación</th>
            <th>Nombre usuario</th>
            <th>Parentesco actual</th>
            <th>
              {{
                mostrarCambioResponsablePagador
                  ? "Parentesco destino"
                  : "Titular destino"
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let integrante of integrantesSinTitular; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ integrante.identificacion }}</td>
            <td>{{ integrante.nombre }}</td>
            <td>{{ integrante.parentesco }}</td>
            <td class="titular-destino">
              <mat-form-field
                *ngIf="
                  mostrarCambioResponsablePagador;
                  else radioNuevoTitularTpl
                "
                appearance="outline"
                class="full-width"
              >
                <mat-select
                  [value]="$any(integrante).parentescoDestino || null"
                  [disabled]="disabled || !cambioTitularRequisitosPreviosOk"
                  (selectionChange)="
                    onParentescoDestinoCambioResponsable(
                      integrante,
                      $event.value
                    )
                  "
                >
                  <mat-option [value]="null" disabled>
                    Nuevo parentesco
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let p of obtenerParentescosDestinoCambioResponsable(
                        integrante
                      )
                    "
                    [value]="p"
                  >
                    {{ p.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <ng-template #radioNuevoTitularTpl>
                <mat-radio-button
                  [value]="integrante"
                  [checked]="isTitularSeleccionado(integrante)"
                  (change)="seleccionarNuevoTitular(integrante)"
                  [disabled]="disabled || !cambioTitularRequisitosPreviosOk"
                >
                </mat-radio-button>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="no-integrantes" *ngIf="integrantesSinTitular.length === 0">
      <mat-icon>info</mat-icon>
      <span>{{
        mostrarCambioResponsablePagador
          ? "No hay integrantes para asignar parentesco destino."
          : "No hay otros integrantes en el contrato para seleccionar como nuevo titular."
      }}</span>
    </div>
  </div>

  <div class="seccion-nuevo-titular" *ngIf="mostrarCambioResponsablePagador">
    <h3 class="titulo-seccion">CONFIGURACIÓN DÉBITO AUTOMÁTICO</h3>
    <mat-checkbox
      [formControl]="activarDebitoAutomaticoNuevoResponsableControl"
      [disabled]="disabled"
      color="primary"
    >
      Activar débito automático para el nuevo responsable de pago
    </mat-checkbox>

    <div
      class="row mt-3"
      *ngIf="activarDebitoAutomaticoNuevoResponsableControl.value"
    >
      <div class="col-12 col-md-6">
        <mat-radio-group [formControl]="metodoDebitoAutomaticoControl">
          <mat-radio-button value="tarjeta" class="me-3">
            TARJETA DE CRÉDITO
          </mat-radio-button>
          <mat-radio-button value="cuenta"> CUENTA BANCARIA </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div
      class="row mt-2"
      *ngIf="
        activarDebitoAutomaticoNuevoResponsableControl.value &&
        metodoDebitoAutomaticoControl.value === 'tarjeta'
      "
    >
      <div class="col-12">
        <mat-checkbox
          [formControl]="confirmacionGestionTarjetaControl"
          [disabled]="disabled"
          color="primary"
        >
          He solicitado al contratante ingresar a la app de Coomeva Medicina
          Prepagada para registrar los datos de su tarjeta de crédito.
        </mat-checkbox>
      </div>
    </div>

    <div
      class="row mt-2"
      *ngIf="
        activarDebitoAutomaticoNuevoResponsableControl.value &&
        metodoDebitoAutomaticoControl.value === 'cuenta'
      "
    >
      <div class="col-12 col-md-3">
        <label class="field-label">Tipo de cuenta *</label>
        <mat-radio-group [formControl]="tipoCuentaDebitoControl">
          <mat-radio-button value="AHO" class="me-3">Ahorros</mat-radio-button>
          <mat-radio-button value="CTE">Corriente</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-12 col-md-3">
        <label class="field-label">Banco *</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [formControl]="bancoDebitoControl">
            <mat-option
              *ngFor="let b of bancosDebitoAutomatico"
              [value]="b.codigo"
            >
              {{ b.nombre }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="bancoDebitoControl.hasError('required')">
            El banco es obligatorio.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <label class="field-label">Nro. de cuenta *</label>
        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            [formControl]="numeroCuentaDebitoControl"
            maxlength="12"
            inputmode="numeric"
            (input)="soloNumeros($event, 12)"
          />
          <mat-error *ngIf="numeroCuentaDebitoControl.hasError('required')">
            El número de cuenta es obligatorio.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12">
        <div
          class="alert alert-danger py-2 mb-0 d-flex align-items-center"
          role="alert"
        >
          <mat-icon class="me-2 flex-shrink-0">notifications</mat-icon>
          <span>
            Recuerde que el número de cuenta registrado debe pertenecer al nuevo
            responsable pagador.
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="seccion-fecha-inicio-novedad">
  <app-info-alert title="Fecha inicio de novedad">
    Seleccione la fecha en que comenzará a aplicar la novedad solicitada.
  </app-info-alert>

  <div class="form-row fecha-aplicacion-fila">
    <div class="col-12 col-md-4">
      <div class="fecha-aplicacion-label-row">
        <mat-icon
          class="fecha-aplicacion-info-icon"
          matTooltip="Seleccione la fecha en que comenzará a aplicar la novedad solicitada."
          matTooltipClass="tooltip-subtipo-custom"
          matTooltipPosition="above"
          >info</mat-icon
        >
        <label class="field-label fecha-aplicacion-label-text"
          >Fecha de aplicación *</label
        >
      </div>
      <mat-form-field appearance="outline" class="select-field full-width">
        <input
          matInput
          [matDatepicker]="pickerFechaAplicacionNovedad"
          [formControl]="fechaAplicacionNovedadControl"
          [disabled]="disabled || readonly"
          (dateChange)="onFechaAplicacionNovedadUsuarioCambio()"
          autocomplete="off"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerFechaAplicacionNovedad"
          [disabled]="disabled || readonly"
        ></mat-datepicker-toggle>
        <mat-datepicker
          #pickerFechaAplicacionNovedad
          [disabled]="disabled || readonly"
        ></mat-datepicker>
        <mat-hint>Fecha en que comienza a aplicar el traslado.</mat-hint>
        <mat-error
          *ngIf="
            fechaAplicacionNovedadControl.invalid &&
            (fechaAplicacionNovedadControl.dirty ||
              fechaAplicacionNovedadControl.touched)
          "
        >
          La fecha de aplicación es obligatoria
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="col-12" *ngIf="fechaAplicacionNovedadDefaultError">
    <div
      class="alert alert-warning d-flex align-items-center flex-wrap gap-2"
      role="alert"
    >
      <mat-icon>info</mat-icon>
      <span>
        No se pudo calcular la fecha sugerida desde el corte del contrato
        destino. Puede seleccionar la fecha manualmente o reintentar el
        cálculo.
      </span>
      <button
        mat-stroked-button
        type="button"
        color="primary"
        (click)="reintentarFechaAplicacionNovedadPorDefecto()"
      >
        <mat-icon>refresh</mat-icon>
        Reintentar
      </button>
    </div>
  </div>
</div>
